module.exports = __webpack_public_path__ + "img/image-1.e8aced7f.jpg";